import React from "react";

import createNamespace from "services/language";
import Route, {
  ADMIN_PREFIX_WITH_PROJECT,
} from "components/common/History/Route";
import { CLUSTERS, VIRTUAL_CLUSTER } from "utils/constants/routes";
import ProjectContextProvider from "components/common/History/ProjectContextProvider";

const Index = React.lazy(() => import("./index"));
const Create = React.lazy(() => import("./create"));
const Details = React.lazy(() => import("./details"));
const Certificates = React.lazy(() => import("./certificates"));
const ImportClusterModal = React.lazy(() =>
  import("../../components/common/NewCluster/ImportCluster")
);
const CreateNestedCluster = React.lazy(() =>
  import("components/common/NestedClusters/create")
);
const SelectCloudModal = React.lazy(() =>
  import("./create/components/SelectCloudModal")
);
const CreateVirtualCluster = React.lazy(() =>
  import("pages/dev/nestedcluster/create")
);
const ApplianceOverview = React.lazy(() => import("./appliances/overview"));
const ClusterPair = React.lazy(() => import("./pairing"));
const RemoteShell = React.lazy(() => import("./appliances/remoteShell"));

export default createNamespace({
  namespace: "clusters",
  Component: function Main() {
    return (
      <>
        <Route adminEnabled exact path={CLUSTERS.ROOT} component={Index} />
        <Route
          exact
          path={CLUSTERS.APPLIANCES_OVERVIEW}
          component={ApplianceOverview}
        />

        <Route
          exact
          adminOnly
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTERS.APPLIANCES_OVERVIEW
          }`}
          component={(props) => {
            return (
              <ProjectContextProvider>
                <ApplianceOverview {...props} />
              </ProjectContextProvider>
            );
          }}
        />
        <Route
          exact
          adminOnly
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTERS.SCAN_DETAILS
          }`}
          component={Details}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTERS.CREATE_CLUSTER}
          component={Create}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTERS.PAIRING}
          component={ClusterPair}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTERS.IMPORT_CLUSTER}
          component={(props) => {
            return <ImportClusterModal />;
          }}
        />
        <Route
          exact
          path={CLUSTERS.NEW_VIRTUAL_CLUSTER}
          component={CreateNestedCluster}
        />
        <Route
          adminEnabled
          path={CLUSTERS.SELECT_CLOUD}
          component={SelectCloudModal}
        />
        <Route
          exact
          path={VIRTUAL_CLUSTER.CREATE_CLUSTER}
          component={CreateVirtualCluster}
        />

        <Route
          exact
          adminEnabled
          path={CLUSTERS.CREATE_CLUSTER_WITH_SELECTED_PROFILE}
          component={Create}
        />
        <Route
          exact
          adminEnabled
          devEnabled
          path={CLUSTERS.CLUSTER_DETAILS}
          component={(props) => {
            if (
              [
                "overview",
                "appliances",
                "new",
                "mapview",
                "virtual",
                "import",
              ].includes(props.match?.params?.id)
            ) {
              return null;
            }
            return <Details {...props} />;
          }}
        />
        <Route
          exact
          adminOnly
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTERS.TAB_DETAILS
          }`}
          component={(props) => (
            <ProjectContextProvider>
              <Details {...props} />
            </ProjectContextProvider>
          )}
        />
        <Route
          adminEnabled
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTERS.CERTIFICATES
          }`}
          component={(props) => (
            <ProjectContextProvider>
              <Certificates {...props} />
            </ProjectContextProvider>
          )}
        />
        <Route
          exact
          adminEnabled
          devEnabled
          path={CLUSTERS.TAB_DETAILS}
          component={Details}
        />
        <Route
          exact
          adminEnabled
          devEnabled
          path={CLUSTERS.SCAN_DETAILS}
          component={Details}
        />
        <Route
          adminEnabled
          devEnabled
          path={CLUSTERS.CERTIFICATES}
          component={Certificates}
        />
        <Route
          exact
          adminEnabled
          path={CLUSTERS.IPAM_DNS_DETAILS}
          component={Details}
        />
        <Route
          adminEnabled
          exact
          path={CLUSTERS.REMOTE_SHELL}
          component={RemoteShell}
        />
        <Route
          exact
          adminOnly
          path={`${ADMIN_PREFIX_WITH_PROJECT.replace("/admin", "")}${
            CLUSTERS.REMOTE_SHELL
          }`}
          component={(props) => {
            return (
              <ProjectContextProvider>
                <RemoteShell {...props} />
              </ProjectContextProvider>
            );
          }}
        />
      </>
    );
  },
});
